import React, { type DetailedHTMLProps, type HTMLAttributes, forwardRef } from "react";
import { twJoin } from "tailwind-merge";

interface MarkProps extends DetailedHTMLProps<HTMLAttributes<HTMLSpanElement>, HTMLSpanElement> {
  active: boolean;
}

export const Mark = forwardRef<HTMLSpanElement, MarkProps>(function Dot({ active, className, ...restProps }, ref) {
  return (
    <span ref={ref} {...restProps} className={twJoin("block -translate-x-1/2", className)}>
      <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 10 10" fill="none">
        <rect x="0.75" y="1" width="8" height="8" rx="4" className={!active ? "fill-primary-100" : "fill-primary-500"} />
        <rect x="0.75" y="1" width="8" height="8" rx="4" className={!active ? "stroke-primary-500" : "stroke-primary-600"} />
      </svg>
    </span>
  );
});
